import fetch from '../utils/fetch';


export function getImgVerifycode() {
  return fetch({
    method: 'GET',
    url: '/user/getImgVerifycode',
  })
}

export function organTree() {
  return fetch({
    method: 'GET',
    url: '/organ/organTree',
  })
}


export function organList(params) {
  return fetch({
    method: 'GET',
    url: '/organ/organListPaging',
    params
  })
}
export function orgcodecreate(params) {
  return fetch({
    method: 'GET',
    url: '/organ/createOrgCode',
    params
  })
}
export function organadd(params) {
  return fetch({
    method: 'POST',
    url: '/organ/add',
    data:params
  })
}
export function organmodify(params) {
  return fetch({
    method: 'POST',
    url: '/organ/modify',
    data:params
  })
}

export function organdelete(params) {
  return fetch({
    method: 'GET',
    url: '/organ/delete',
    params
  })
}






export function roleget(params) {
  return fetch({
    method: 'GET',
    url: '/role/get',
    params
  })
}

export function rolelist(params) {
  return fetch({
    method: 'POST',
    url: '/role/list',
    data:params
  })
}
export function roleedit(params) {
  return fetch({
    method: 'POST',
    url: '/role/edit',
    data:params
  })
}

export function rolecopyRolelist(params) {
  return fetch({
    method: 'POST',
    url: '/role/copyRolelist',
    data:params
  })
}


export function roleblockUp(params) {
  return fetch({
    method: 'GET',
    url: '/role/blockUp',
    params
  })
}

export function rolecondition(params) {
  return fetch({
    method: 'POST',
    url: '/role/condition',
    data:params
  })
}
export function roleadd(params) {
  return fetch({
    method: 'POST',
    url: '/role/add',
    data:params
  })
}

export function menuTree() {
  return fetch({
    method: 'GET',
    url: '/menu/menuTree'
  })
}

export function menuModify(params) {
  return fetch({
    method: 'POST',
    url: '/menu/modify',
    data:params
  })
}

export function menuList(params) {
  return fetch({
    method: 'GET',
    url: '/menu/menuList',
    params
  })
}

export function menuAdd(params) {
  return fetch({
    method: 'POST',
    url: '/menu/add',
    data:params
  })
}

export function updateMenuStatus(params) {
  return fetch({
    method: 'POST',
    url: '/menu/updateMenuStatus',
    data:params
  })
}

export function getMenuDetail(params) {
  return fetch({
    method: 'GET',
    url: '/menu/getMenuDetail',
    params
  })
}
